import React, { useState } from 'react'
import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css'
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import './Calendar.scss'
import { SvgIcon } from '@mui/material'
import moment from 'moment'

const weekDays = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
]

const Calender = ({
  currentDate,
  minDate,
  maxDate,
  setSelectedDate,
  stylistAvailability,
}) => {
  const [date, setDate] = useState(new Date())

  const handleDateChange = (date) => {
    setSelectedDate(moment(new Date(date)).format('YYYY-MM-DD'))
    // (new Date(date).getDate(), ' calender change event')
  }
  const formatDay = (date) => {
    let day = weekDays[new Date(date).getDay() - 1]
    if (day === undefined) {
      return 'S'
    }
    return day.charAt(0)
  }

  return (
    <div className="calendar">
      <Calendar
        className={'calendar'}
        onChange={handleDateChange}
        value={date}
        prevLabel={<SvgIcon component={ArrowLeftIcon} />}
        nextLabel={<ArrowRightIcon />}
        prev2Label={null}
        next2Label={null}
        formatShortWeekday={(locale, date) => formatDay(date)}
        minDate={minDate}
        // maxDate={!stylistAvailability ? maxDate : undefined}
        tileClassName="selected-day"
        // tileDisabled={({ date }) => {
        //   if (stylistAvailability) {
        //     let dateDay = weekDays[date.getDay()]
        //     let availabilityDay = stylistAvailability?.find(
        //       (el) => el.day?.toLowerCase() === dateDay.toLowerCase(),
        //     )
        //     if (availabilityDay?.is_working == false) {
        //       return true
        //     }
        //   }
        // }}
      />
    </div>
  )
}

export default Calender
